import { useMemo } from "react";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../app/helpers";
import { RootState } from "../../../app/rootReducer";
import type { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import type { DayWorkStatus } from "../types/dashboard2-work-status.types";
import { getPublicHolidayNameForDay } from "../utils/dashboard2-public-holidays.utils";
import { deriveDayWorkStatusForUser } from "../utils/dashboard2-schedule.utils";
import { resolveDashboard2BookingTypeLabel } from "../utils/dashboard2-booking-type-label.utils";
import useTimeFormat from "../../../hooks/useTimeFormat/useTimeFormat";

export function useDashboard2TodayStatus(
  schedules: BookingScheduleInterface[],
  userId: string
): DayWorkStatus {
  const { t, i18n } = useTranslation();
  const { timeFormat } = useTimeFormat();
  const checkinSettings = useSelector(
    (state: RootState) => state.login.userInformation.company.meta.checkinSettings
  );

  return useMemo(() => {
    const today = DateTime.now();
    const holidayName = getPublicHolidayNameForDay(today, i18n.language);

    return deriveDayWorkStatusForUser(schedules, userId, today, {
      mobileWorkingLabel: t("_dashboard2_statusMobileWorking"),
      notSetLabel: t("_dashboard2_statusNotSet"),
      holidayName,
      checkinSettings,
      timeFormat,
      resolveBookingTypeLabel: (bookingType: string) =>
        resolveDashboard2BookingTypeLabel(bookingType, t),
      resolveExternalLabel: () => t("_dashboard2_bookingParticipantTagExternal")
    });
  }, [checkinSettings, i18n.language, schedules, t, timeFormat, userId]);
}
